/**
 * PublicHomePage
 * Minimal landing page with hero section and key sections
 */

import React from "react";
import { useNavigate } from "react-router-dom";
import AIAssistantTeaser from "../../components/public/AIAssistantTeaser";
import HeroSection from "../../components/public/HeroSection";
import PublicFooter from "../../components/public/PublicFooter";
import PublicHeader from "../../components/public/PublicHeader";
import TrustSection from "../../components/public/TrustSection";

const PublicHomePage: React.FC = () => {
	const navigate = useNavigate();

	// Navigate to properties page instead of scrolling
	const handleViewProperties = () => {
		navigate("/properties");
	};

	return (
		<div className="min-h-screen bg-background">
			{/* Header */}
			<PublicHeader onScrollToProperties={handleViewProperties} />

			{/* Hero Section */}
			<HeroSection onViewProperties={handleViewProperties} />

			{/* AI Assistant Teaser */}
			<AIAssistantTeaser />

			{/* Trust/Value Props Section */}
			<TrustSection />

			{/* Footer */}
			<PublicFooter />
		</div>
	);
};

export default PublicHomePage;
